import React, { useContext, useEffect, useRef, useState } from 'react'
import '../../../Components/FileInput.css'
import { MdOutlineFileUpload } from 'react-icons/md';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ContextNotification, severitys } from '../../../App';
import enumMapper from '../../../enumMapper';

import fileAttachmentApi from '../../../api/fileAttachmentApi';
import BeatLoading from '../../../Components/Loader/BeatLoader';

const GuestFileInput = ({ fileAttachmentType, guestPassengerId, refreshGrid }) => {
    const { open, setOpen } = useContext(ContextNotification);
    const inputRef = useRef();
    const [msg, setMsg] = useState("")
    const [loading, setLoading] = useState(false);
    const handleOnChange = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            if (fileAttachmentType.toString() !== enumMapper.FileAttachmentType.PassportImage.toString() && !fileValidation(event.target.files[0])) {
                setMsg("فرمت های مجاز pdf,jpeg,jpg,png")
                return;
            }
            else if (fileAttachmentType.toString() === enumMapper.FileAttachmentType.PassportImage.toString()) {
                if (!passportValidation(event.target.files[0])) {
                    setMsg("فرمت های مجاز jpeg,jpg")
                    return;
                }
                if (!passportSizeValidation(event.target.files[0])) {
                    setMsg(`حجم فایل ` + formatBytes(event.target.files[0].size, 2) + ` \n حجم مجاز کمتر از 500 کیلو بایت و بیشتر از 30 کیلو بایت `)
                    return;
                }
            }
            setLoading(true);
            const formData = new FormData();
            formData.append("GuestPassengerId", guestPassengerId);
            formData.append("FileAttachmentType", fileAttachmentType)
            formData.append("Iformfile", event.target.files[0]);

            fileAttachmentApi.Add(formData)
                .then((res) => {
                    if (res.data.success) {
                        setMsg("")
                        refreshGrid(true);
                        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                    }
                    else {
                        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
                    }
                }).catch(err => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                    }
                    else if (err.response && err.response.data) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
                    }
                    else if (err.message) {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
                    }
                    else {
                        setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
                    }
                }
                ).finally(() => setLoading(false));
        }
    }
    const onChooseFile = (event) => {
        event.preventDefault();
        inputRef.current.click()
    }
    const fileValidation = (element) => {
        let valid = true;
        if (element.type !== "image/jpeg" && element.type !== "image/png" && element.type !== "image/jpg" && element.type !== "application/pdf") {
            valid = false;
        }
        return valid;
    }

    const passportValidation = (element) => {
        let valid = true;
        if (element.type !== "image/jpeg" && element.type !== "image/jpg") {
            valid = false;
        }
        return valid;
    }

    const passportSizeValidation = (element) => {
        let valid = true;

        const size = element.size / 1024

        if (size < 30 || size > 500) {
            valid = false;
        }
        return valid;
    }
    function formatBytes(bytes, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['بایت', 'کیلو بایت', 'مگابایت', 'گیگا بایت', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    return (
        <>
            <input type='file'
                name='file'
                ref={inputRef}
                onChange={handleOnChange}
                style={{ display: "none" }} />
            <button className='file-btn' onClick={onChooseFile}><span style={{ display: 'flex', alignItems: 'center' }}><MdOutlineFileUpload size={20} /><span>انتخاب فایل</span></span>
            </button>
            <p className="error display-linebreak">{msg}</p>
            <BeatLoading loading={loading} color={"#e65100"} size={8} />
        </>
    )
}

export default GuestFileInput